import Component from '@glimmer/component';
import type CoverModel from 'frontend/models/cover';
import config from 'frontend/config/environment';

interface FormationPartsIntroductionCoverComponentArgs {
  cover: CoverModel;
}

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class FormationPartsIntroductionCoverComponent extends Component<FormationPartsIntroductionCoverComponentArgs> {
  config = config;
}
